module.exports = __webpack_public_path__ + "static/img/1vr3.4195737c.png";